import types from './types'

export const updateMutation = (key: string, payload: Record<string, any>) => ({
  type: types.UPDATE_MUTATION,
  key,
  payload,
})
